// @flow

import type { StrengthType } from './types';

import {
  STRONG, MEDIUM, WEAK, NONE
} from './constants';

export const isStrong = (password: string): boolean =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(password);
export const isMedium = (password: string): boolean =>
  /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/.test(
    password
  );
export const isWeak = (password: string): boolean => password.length > 0;

export const isPasswordValid = isStrong;

export const getStrength = (password: string): StrengthType => {
  if (isStrong(password)) return STRONG;

  if (isMedium(password)) return MEDIUM;

  if (isWeak(password)) return WEAK;

  return NONE;
};
